import React from 'react';
import styled from 'styled-components';
import _get from 'lodash.get';

import Box from '@ntuctech/devex-tangram/Box';
import Typography from '@ntuctech/devex-tangram/Typography';

import { TnCLink, PrivacyLink } from './Links';
import { useAuth0 } from '../../Auth0Provider';

const StyledTnC = styled(Box)`
  & p {
    color: #4d4d4d;
  }

  ul {
    list-style-position: inside;
    margin: 0;
    padding: 0 0 0 0.5rem;
  }
`;

const TnC = (props) => {
  const { userContext } = useAuth0();

  const { type } = props;

  const seName = React.useMemo(() => _get(userContext, 'clientBasedUi.seName'), [userContext]);
  const tncLink = React.useMemo(() => _get(userContext, 'clientBasedUi.tncLink'), [userContext]);
  const privacyLink = React.useMemo(
    () => _get(userContext, 'clientBasedUi.privacyLink'),
    [userContext],
  );
  const hasCustomTnc = React.useMemo(() => Boolean(tncLink && privacyLink), [tncLink, privacyLink]);

  const fpgOnlyLinks = (
    <>
      <TnCLink data-testid={`${type}TncLinkTermsFPG`} /> and{' '}
      <PrivacyLink data-testid={`${type}TncLinkPrivacyFPG`} />
    </>
  );

  return (
    <StyledTnC pt={1} data-testid={`${type}TncContainer`}>
      <Typography variant="body4">
        {!hasCustomTnc && type === 'welcome' && (
          <>You acknowledge that you have read and agreed to our {fpgOnlyLinks}. </>
        )}
        {type === 'welcome' && (
          <>
            If you are a new user signing up with Apple or Google, you agree to receive marketing
            communications from us. If you do not want to receive marketing communications, sign up
            with your email address or mobile number instead.
          </>
        )}
        {!hasCustomTnc && type === 'signup' && (
          <>
            By creating an account with us, you acknowledge you have read and agreed to our{' '}
            {fpgOnlyLinks}.
          </>
        )}
        {hasCustomTnc && type === 'welcome' && (
          <>
            <br />
            <br />
            You acknowledge that you have read and agreed to:
          </>
        )}
        {hasCustomTnc && type === 'signup' && (
          <>By creating an account with us, you acknowledge that you have read and agreed to:</>
        )}
        {hasCustomTnc && (
          <>
            <ul>
              <li>FairPrice Group’s {fpgOnlyLinks}</li>
              <li>
                {seName}’s <TnCLink data-testid={`${type}TncLinkTermsSE`} url={tncLink} /> and{' '}
                <PrivacyLink data-testid={`${type}TncLinkPrivacySE`} url={privacyLink} />
              </li>
            </ul>
          </>
        )}
      </Typography>
    </StyledTnC>
  );
};

export default TnC;
